import React from "react";

/**
 * Ícones SVG do chat Tailwick — sem Material-UI (padrão Lucide / tema).
 */
export function TailwickIcon({ children, size = 18, className = "" }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			className={`shrink-0 ${className}`.trim()}
			aria-hidden
		>
			{children}
		</svg>
	);
}

export function IconChatOpen(props) {
	return (
		<TailwickIcon {...props}>
			<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
		</TailwickIcon>
	);
}

/** Tickets pendentes — balão com alerta (igual Announcement do layout clássico). */
export function IconTicketsPending(props) {
	const { size = 18, className = "" } = props;
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			className={`shrink-0 ${className}`.trim()}
			aria-hidden
		>
			<path
				fill="currentColor"
				d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
			/>
		</svg>
	);
}

/** Status de perfil — anel tracejado (estilo Status do WhatsApp). */
export function IconProfileStatus(props) {
	return (
		<TailwickIcon {...props} strokeWidth="1.85">
			<circle
				cx="12"
				cy="12"
				r="9"
				strokeDasharray="4.25 2.75"
				strokeLinecap="round"
			/>
		</TailwickIcon>
	);
}

/** Avatar padrão — silhueta de usuário (sem anel externo). */
export function IconUserStatus(props) {
	return (
		<TailwickIcon {...props}>
			<circle cx="12" cy="8" r="4" />
			<path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
		</TailwickIcon>
	);
}

export function IconTicketsClosed(props) {
	return (
		<TailwickIcon {...props}>
			<rect width="18" height="18" x="3" y="3" rx="2" />
			<path d="m9 12 2 2 4-4" />
		</TailwickIcon>
	);
}

/** Filtros — sliders horizontais (distinto do funil). */
export function IconFilters(props) {
	return (
		<TailwickIcon {...props}>
			<line x1="21" x2="14" y1="4" y2="4" />
			<line x1="10" x2="3" y1="4" y2="4" />
			<line x1="21" x2="12" y1="12" y2="12" />
			<line x1="8" x2="3" y1="12" y2="12" />
			<line x1="21" x2="16" y1="20" y2="20" />
			<line x1="12" x2="3" y1="20" y2="20" />
			<line x1="14" x2="14" y1="2" y2="6" />
			<line x1="8" x2="8" y1="10" y2="14" />
			<line x1="16" x2="16" y1="18" y2="22" />
		</TailwickIcon>
	);
}

/** Funil de vendas — etapas em colunas (pipeline / kanban). */
export function IconSalesFunnel(props) {
	return (
		<TailwickIcon {...props}>
			<rect x="3" y="3" width="5" height="18" rx="1.25" />
			<rect x="9.5" y="7" width="5" height="14" rx="1.25" />
			<rect x="16" y="11" width="5" height="10" rx="1.25" />
		</TailwickIcon>
	);
}

export function IconChevronLeft(props) {
	return (
		<TailwickIcon {...props}>
			<path d="m15 18-6-6 6-6" />
		</TailwickIcon>
	);
}

export function IconSearch(props) {
	return (
		<TailwickIcon {...props}>
			<circle cx="11" cy="11" r="8" />
			<path d="m21 21-4.3-4.3" />
		</TailwickIcon>
	);
}

export default {
	TailwickIcon,
	IconChatOpen,
	IconTicketsPending,
	IconProfileStatus,
	IconUserStatus,
	IconTicketsClosed,
	IconFilters,
	IconSalesFunnel,
	IconChevronLeft,
	IconSearch,
};
